import type { SettingsRecord } from "@/runtime/events";

import { getRecord, putRecord } from "./db";

const DEFAULT_SETTINGS: SettingsRecord = {
  id: "app-settings",
  cloudKeysPersisted: false,
  preferredRoute: "conversation",
  lastUpdatedAt: new Date(0).toISOString(),
};

export async function loadSettings(): Promise<SettingsRecord> {
  return (await getRecord<SettingsRecord>("settings", "app-settings")) ?? DEFAULT_SETTINGS;
}

export async function saveSettings(
  nextSettings: Omit<SettingsRecord, "id">,
): Promise<SettingsRecord> {
  const record: SettingsRecord = {
    id: "app-settings",
    ...nextSettings,
  };
  await putRecord("settings", record);
  return record;
}
